import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import Button from '../../../../Common/Button';
import SbUtils from '../../../../../Utils/SbUtils';


const InstallSnippetLibrary = ({ sbCustomizer, editorNotification, editorTopLoader }) => {
    const [showLoader, setShowLoader] = useState(false);
    const wpCode = sbCustomizer?.wpCode || {};
    const ctaTitle = !wpCode?.pluginInstalled ?
        __('Install WPCode to use Smash Balloon Snippet library', 'sb-customizer') :
        __('Activate WPCode to use Smash Balloon Snippet library', 'sb-customizer');

    const ctaButtonText = !wpCode?.pluginInstalled ?
        __('One-click Install WPCode', 'sb-customizer') :
        __('Activate WPCode', 'sb-customizer');

    const icon = showLoader ? 'loader' : (wpCode?.pluginInstalled && !wpCode?.pluginActive ? false : 'download-install');

    const installActivatePlugin = () => {
        setShowLoader(true);
        let plugin = 'https://downloads.wordpress.org/plugin/insert-headers-and-footers.zip',
            action = 'install';

        if (wpCode?.pluginInstalled && !wpCode?.pluginActive) {
            plugin = wpCode?.isProInstalled ? 'wpcode-premium/wpcode.php' : 'insert-headers-and-footers/ihaf.php';
            action = 'activate';
        }

        let formData = {
            action: action === 'install' ? 'sbtt_install_plugin' : 'sbtt_activate_plugin',
            plugin: plugin
        },
            notificationsContent = {
                type: 'success',
                icon: 'success',
                text: action === 'install' ? __('Plugin Installed', 'sb-customizer') : __('Plugin Activated', 'sb-customizer')
            }

        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => { //Call Back Function
                setShowLoader(false);
                if (data.success === false) {
                    data = data?.data[0] ?? data;
                    notificationsContent = {
                        type: 'error',
                        icon: 'notice',
                        text: data?.message ? data?.message : __('Unknown Error', 'sb-customizer')
                    }
                    SbUtils.applyNotification(notificationsContent, editorNotification);
                } else {
                    data = data?.data ?? data;
                    SbUtils.applyNotification(notificationsContent, editorNotification);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            },
            editorTopLoader,
            null,
            null
        )
    }

    return (
        <div className='sb-wpcode-install-snippets'>
            <div className='sb-wpcode-install-snippets-content'>
                {SbUtils.printIcon('wpcode')}

                <div className='sb-wpcode-install-snippets-header'>
                    <p className='sb-wpcode-install-snippets-header-title'>
                        {ctaTitle}
                    </p>

                    <p className='sb-wpcode-install-snippets-header-description'>
                        {__('Using WPCode you can install Smash Balloon code snippets with 1-click directly from this page or the WPCode library inside the WordPress admin.', 'sb-customizer')}
                    </p>
                </div>
            </div>

            <div className='sb-wpcode-install-cta-section'>
                <Button
                    type='primary'
                    size='medium'
                    text={ctaButtonText}
                    icon={icon}
                    iconSize='16'
                    icon-position='left'
                    onClick={() => {
                        installActivatePlugin();
                    }}
                />

                <Button
                    type='secondary'
                    size='medium'
                    text={__('Learn More', 'sb-customizer')}
                    icon='chevron-right'
                    iconSize='8'
                    boxshadow={false}
                    icon-position='right'
                    full-width={true}
                    link={'https://smashballoon.com/doc/how-does-the-wpcode-integration-work/?utm_content=learn-more'}
                    target='_blank'
                />
            </div>
        </div>
    );
}

export default InstallSnippetLibrary;